import type { ServiceProvider } from "./ServiceProvider";
import { BaseServiceContainer } from "./BaseServiceContainer";

/**
 * Creates service container.
 *
 * @param providers
 * @internal
 */
export function createServiceContainer(
  providers: ServiceProvider[] = []
): BaseServiceContainer {
  const serviceLocator = new BaseServiceContainer();
  providers.forEach((provider) => provider.register(serviceLocator));
  return serviceLocator;
}
